<template>
  <Modal
    :title="quoteName"
    class-name="task-picker-modal"
    no-submit
    @show-modal="modalVisible = true"
    @hide-modal="$emit('hide-modal')"
  >
    <div>
      <TextField
        v-model="searchField"
        labelClass="search-task-box mb-3 full-width"
        type="search"
        :placeholder="searchPlaceHolder"
      />
    </div>
    <Transition>
      <TaskPicker
        v-if="modalVisible"
        :tree="tasksTree"
        :search="searchField"
        class="picker"
        :membership-program-id="quote.actual_membership_program_id"
        :replace-task-id="replacingTaskId"
        @add-task="addTask"
        @replace-task="replaceTask"
        @category-change="categoryChange"
        @search-cleared="handleSearchCleared"
      />
    </Transition>
    <template #submit>
      <div></div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import TextField from "@/components/TextField.vue";
import Modal from "../../components/Modal.vue";
import Transition from "../../components/Transition.vue";

export default {
  components: {
    Modal,
    TextField,
    Transition
  },
  props: {
    quoteName: {
      type: String,
      default: "Add Item"
    },
    quote: {
      type: Object,
      default: () => ({})
    },
    replacingTask: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      searchField: "",
      searchPlaceHolder: "Search All Tasks",
      modalVisible: false
    };
  },
  computed: {
    ...mapState(["tasksTree"]),
    replacingTaskId() {
      return this.replacingTask ? this.replacingTask.item_id : null;
    }
  },
  mounted() {
    this.fetchTasksTree({ quoteId: this.quote.id });
  },
  methods: {
    ...mapActions(["fetchTasksTree", "addItem"]),
    addTask(tasks, task, addons, doneCallback) {
      const action_url = this.quote.links.line_item_create;
      this.performAddItemCall(
        { tasks, task, addons, doneCallback },
        action_url
      );
    },
    replaceTask(tasks, task, addons, doneCallback) {
      const action_url = this.replacingTask.links.line_item_replace;
      this.performAddItemCall(
        { tasks, task, addons, doneCallback },
        action_url,
        "replaced"
      );
    },
    performAddItemCall(taskPickerData, action_url, successAction) {
      const { tasks, task, addons, doneCallback } = taskPickerData;
      this.addItem({
        url: action_url,
        payload: {
          items: this.parseTasksToItems(tasks)
        }
      })
        .then(() => {
          const message = this.getSuccessMessage(task, addons, successAction);
          window.notify.success(message);
          if (successAction === "replaced") {
            this.$emit("hide-modal");
          }
        })
        .finally(() => {
          if (doneCallback) {
            doneCallback();
          }
        });
    },
    parseTasksToItems(tasks) {
      return tasks.map((task) => {
        const itemDetails = {
          item_id: task.id,
          item_type: task.kind,
          quantity: 1
        };
        if (task.unit_price_cents) {
          itemDetails.unit_price_cents = task.unit_price_cents;
        }
        return itemDetails;
      });
    },
    categoryChange(category) {
      this.searchPlaceHolder = `Search ${category.name || "All"} Tasks`;
    },
    getSuccessMessage(task, addons, action = "added") {
      let message = `Successfully ${action} ${task.name}`;
      if (addons.length) {
        const plural = addons.length > 1;
        message += ` and ${addons.length} add-on${plural ? "s" : ""}`;
      }
      return message;
    },
    handleSearchCleared() {
      this.searchField = "";
    }
  }
};
</script>

<style lang="scss">
.search-task-box {
  margin-bottom: 0px;
  width: 100%;
}
.picker {
  height: calc(100% - 50px) !important;
  font-size: 1rem;
}
.task-picker-modal {
  .modal-body {
    height: 80vh;
    .col-md-12.parsley-validations {
      height: 100%;
    }
  }
}
</style>
